import { FormlyFieldConfig } from 'ng-formly';
export const emailFields: Array<FormlyFieldConfig> = [
    {
        key: 'from',
        type: 'select-component',
        templateOptions: {
            type: 'entityrecord',
            placeholder: 'from@email.com',
            required: true,
            label: 'From'
        }
    }, {
        key: 'recipienttype',
        type: 'select-component',
        templateOptions: {
            options: [{
                label: 'External',
                value: 'external'
            }, {
                label: 'Internal',
                value: 'internal'
            }],
            label: 'Recipient Type',
            required: true
        }
    },
    /*
    {
        key: 'to',
        type: 'select-component',
        templateOptions: {
            type: 'entityrecord',
            placeholder: 'to@email.com',
            required: true,
            label: 'To'
        }
    },
    */
    {
        key: 'to',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'To Email Address'
        }
    },
    {
        key: 'subject',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Subject'
        }
    },
    {
        key: 'text',
        type: 'textarea-field',
        templateOptions: {
            rows: 10,
            label: 'Body'
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/email.ts